import { IRefIds } from 'constants/refs';
import { del, get, post, put } from 'services/request';
import { BaseModel, IModelOptions } from './BaseModel';
import { IItemId } from '../types/content';
import { IMemoryMeansTemplateSet, IMemoryMeansTemplateSetEdit } from '../types/memoryMeansTemplateSet';

export default class MemoryMeansTemplateSetsModel extends BaseModel<IMemoryMeansTemplateSet, IMemoryMeansTemplateSetEdit> {
  constructor(options: IModelOptions) {
    super(options);
    this.ref = IRefIds.NONE; // Not tied to a ref entity
    this.gridName = 'MemoryMeansTemplateSets';
    this.getGridColumns();
    this.getGrid();
  }

  async getGrid() {
    await super.getGrid();
    this.gridData = await get<IMemoryMeansTemplateSet[]>(`/memory/means-sets`);
    this.loadingGrid = false;
    this.render();
  }

  async getGridRow(itemId: number) {
    return await get<IMemoryMeansTemplateSet>(`/memory/means-sets/${itemId}`);
  }

  async reload() {
    await super.reload();
    await this.getGrid();
  }

  async new() {
    await super.new();
    const item: IMemoryMeansTemplateSetEdit = {
      id: this.NEW_CREATE_ID,
      em1_bank_item_id: 0,
      em2_bank_item_id: 0,
      em3_bank_item_id: 0,
    };
    await this.setItem(item);
    this.render();
  }

  async save() {
    await super.save();
    const { id } = this.itemUpdated as IMemoryMeansTemplateSetEdit;
    if (id === this.NEW_CREATE_ID) {
      await this.createItem();
    } else {
      await this.updateItem();
    }
  }

  async createItem() {
    const payload = this.itemUpdated as IMemoryMeansTemplateSetEdit;
    const result = await post<IItemId>(`/memory/means-sets`, payload);
    if (result.ok && result.data) {
      const newItemId = (result.data as any).id ?? result.data.id;
      await Promise.all([this.updateGridRow(newItemId, 'add'), this.loadItemEdit(newItemId)]);
    }
  }

  async updateItem() {
    const payload = this.itemUpdated as IMemoryMeansTemplateSetEdit;
    await put(`/memory/means-sets/${payload.id}`, payload);
    await Promise.all([this.updateGridRow(payload.id, 'update'), this.loadItemEdit(payload.id)]);
  }

  async delete() {
    await super.delete();
    const { id } = this.itemUpdated as IMemoryMeansTemplateSetEdit;
    const result = await del(`/memory/means-sets/${id}`);
    if (result.ok) {
      await Promise.all([this.updateGridRow(id, 'remove'), this.new()]);
    }
  }

  async loadItemData(itemId: number) {
    return await get<IMemoryMeansTemplateSetEdit>(`/memory/means-sets/${itemId}`);
  }
}
